module.exports = __webpack_public_path__ + "img/imagen6.0ac75b89.png";